// extracted by mini-css-extract-plugin
export default {"box":"SelectRange_box__r7Go8"};